import React from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";

import { TwoFactorAuthLogsModule } from "./TwoFactorAuthLogsModule";

const BlackListIps = (props) => {
  const { notifications } = props;

  return (
    <ErrorBoundary moduleName="twoFactorAuthLogsModule" {...notifications}>
      <TwoFactorAuthLogsModule />
    </ErrorBoundary>
  );
};

export default BlackListIps;
